module.exports = __webpack_public_path__ + "img/隨緣自強5 的副本.d9ac7de8.jpg";